import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import QRCode from 'qrcode';

export const downloadQRCodesAsExcel = async (qrCodes, filename, fgColor = "#000000", bgColor = "#FFFFFF", logo = null, logoSize = 30) => {
    try {
        // Create a new workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('QR Codes');

        // Set column widths
        worksheet.columns = [
            { header: 'QR Code', key: 'qrcode', width: 30 },
            { header: 'Content', key: 'content', width: 50 }
        ];

        // Style the header row
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).height = 30;

        // Process each QR code
        for (let i = 0; i < qrCodes.length; i++) {
            const qr = qrCodes[i];
            
            // Create QR code
            const canvas = document.createElement('canvas');
            canvas.width = 300;
            canvas.height = 300;

            await QRCode.toCanvas(canvas, qr.content, {
                width: 300,
                margin: 1,
                color: {
                    dark: fgColor,
                    light: bgColor
                },
                errorCorrectionLevel: 'M'
            });

            // If logo is provided, add it to the canvas
            if (logo) {
                const ctx = canvas.getContext('2d');
                const img = new Image();
                await new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = reject;
                    img.src = logo;
                });

                const logoWidth = Math.floor(300 * (logoSize / 100));
                const logoHeight = logoWidth;
                const x = (300 - logoWidth) / 2;
                const y = (300 - logoHeight) / 2;

                // Draw white background for logo
                ctx.fillStyle = bgColor;
                ctx.fillRect(x, y, logoWidth, logoHeight);
                
                // Draw logo
                ctx.drawImage(img, x, y, logoWidth, logoHeight);
            }

            // Convert QR code to base64
            const pngData = canvas.toDataURL("image/png");
            
            // Add row with QR code and content
            const row = worksheet.addRow({ content: qr.content });
            
            // Add image to worksheet
            const imageId = workbook.addImage({
                base64: pngData,
                extension: 'png',
            });

            worksheet.addImage(imageId, {
                tl: { col: 0, row: row.number - 1 },
                ext: { width: 200, height: 200 }
            });

            // Set row height to accommodate QR code
            row.height = 150;
        }

        // Style improvements
        worksheet.eachRow((row) => {
            row.alignment = { vertical: 'middle' };
            row.eachCell((cell) => {
                if (cell.column === 1) { // Content column
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                }
            });
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, filename);

    } catch (error) {
        console.error('Error generating Excel file:', error);
        throw new Error('Failed to generate Excel file');
    }
}; 